import countriesData from "../data/Location/countries.json";

const cityContext = require.context("../data/Location/cities", false, /\.json$/);

const normalize = (value) => String(value || "").trim().toLowerCase();

const countries = Array.isArray(countriesData) ? countriesData : [];

const countryByValue = new Map();
countries.forEach((country) => {
	[country.country, country.ruName, country.iso2, country.iso3].forEach((value) => {
		if (value) countryByValue.set(normalize(value), country);
	});
});

const cityCache = new Map();

const getCountryRow = (value) => countryByValue.get(normalize(value));

const getCityRows = (countryValue) => {
	const country = getCountryRow(countryValue);
	const iso2 = country?.iso2;

	if (!iso2) return [];
	if (cityCache.has(iso2)) return cityCache.get(iso2);

	const key = `./${iso2}.json`;
	if (!cityContext.keys().includes(key)) {
		cityCache.set(iso2, []);
		return [];
	}

	const rawRows = cityContext(key);
	const rows = (Array.isArray(rawRows) ? rawRows : rawRows?.default || [])
		.map((item) => {
			if (typeof item === "string") return { name: item };
			return {
				name: String(item?.name || item?.city || "").trim(),
				ruName: String(item?.ruName || "").trim(),
			};
		})
		.filter((item) => item.name);

	cityCache.set(iso2, rows);
	return rows;
};

export const getCountryLabelRu = (value) => {
	const raw = String(value || "").trim();
	if (!raw) return "-";

	const country = getCountryRow(raw);
	return country?.ruName || country?.country || raw;
};

export const getCityLabelRu = (countryValue, cityValue) => {
	const raw = String(cityValue || "").trim();
	if (!raw) return "-";

	const city = getCityRows(countryValue).find(
		(item) => normalize(item.name) === normalize(raw) || normalize(item.ruName) === normalize(raw),
	);

	return city?.ruName || city?.name || raw;
};
